<template>
  <div>
    <el-card class="filter-card">
      <div class="filter-form">
        <div class="filter-form-left">
          <el-input
            v-model="queryParams.code"
            placeholder="标签编码(A-X)"
            clearable
            style="width: 180px; margin-right: 10px;"
          />
          <el-input
            v-model="queryParams.remark"
            placeholder="标签说明"
            clearable
            style="width: 260px; margin-right: 10px;"
          />
          <el-select
            v-model="queryParams.is_active"
            placeholder="状态"
            clearable
            style="width: 120px; margin-right: 10px;"
          >
            <el-option label="启用" :value="true" />
            <el-option label="停用" :value="false" />
          </el-select>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
        <el-button type="primary" @click="openAddDialog">新增</el-button>
      </div>
    </el-card>

    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="tags"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="code" label="编码" width="100" />
        <el-table-column prop="is_active" label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="row.is_active ? 'success' : 'info'" size="small">
              {{ row.is_active ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="100" />
        <el-table-column prop="remark" label="标签说明" min-width="280">
          <template #default="{ row }">
            {{ row.remark || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180" />
        <el-table-column prop="updated_at" label="更新时间" width="180" />
        <el-table-column label="操作" width="90" fixed="right">
          <template #default="{ row }">
            <el-button size="small" @click="openEditDialog(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <el-dialog v-model="addDialogVisible" title="新增产品标签" width="560px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标签编码" prop="code">
          <el-input
            v-model="form.code"
            maxlength="1"
            placeholder="请输入 A-X"
            @input="onCodeInput"
          />
        </el-form-item>
        <el-form-item label="状态" prop="is_active">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="form.is_active" />
            <span style="margin-left: 8px;">{{ form.is_active ? '启用' : '停用' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="999" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="标签说明" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入标签备注说明（如该标签下常见芯片规格）"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAdd">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog v-model="editDialogVisible" title="编辑产品标签" width="560px">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="标签编码">
          <el-input v-model="editForm.code" disabled />
        </el-form-item>
        <el-form-item label="状态" prop="is_active">
          <div style="display: flex; align-items: center;">
            <el-switch v-model="editForm.is_active" />
            <span style="margin-left: 8px;">{{ editForm.is_active ? '启用' : '停用' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="editForm.sort" :min="0" :max="999" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="标签说明" prop="remark">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入标签备注说明（如该标签下常见芯片规格）"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { createProductTag, getProductTags, updateProductTag } from '@/services/productTag'
import { extractErrorMessage } from '@/utils/errorHandler'

export default {
  name: 'ProductTagMgmt',
  setup() {
    const loading = ref(false)
    const tags = ref([])
    const total = ref(0)
    const currentPage = ref(1)
    const pageSize = ref(20)

    const queryParams = ref({
      code: '',
      remark: '',
      is_active: ''
    })

    const addDialogVisible = ref(false)
    const formRef = ref(null)
    const form = ref({
      code: '',
      is_active: true,
      sort: 0,
      remark: ''
    })
    const rules = {
      code: [
        { required: true, message: '请输入标签编码', trigger: 'blur' },
        { pattern: /^[A-X]$/, message: '标签编码仅支持 A-X', trigger: 'blur' }
      ]
    }

    const editDialogVisible = ref(false)
    const editFormRef = ref(null)
    const currentEditId = ref(null)
    const editForm = ref({
      code: '',
      is_active: true,
      sort: 0,
      remark: ''
    })
    const editRules = {}

    const fetchTags = async () => {
      loading.value = true
      try {
        const params = {
          skip: (currentPage.value - 1) * pageSize.value,
          limit: pageSize.value,
          ...queryParams.value
        }

        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null) {
            delete params[key]
          }
        })

        const data = await getProductTags(params)
        tags.value = data.tags || []
        total.value = data.total || 0
      } catch (error) {
        console.error('获取产品标签失败:', error)
        ElMessage.error(extractErrorMessage(error, '获取产品标签失败'))
      } finally {
        loading.value = false
      }
    }

    const handleSizeChange = (size) => {
      pageSize.value = size
      currentPage.value = 1
      fetchTags()
    }

    const handleCurrentChange = (page) => {
      currentPage.value = page
      fetchTags()
    }

    const handleSearch = () => {
      currentPage.value = 1
      fetchTags()
    }

    const resetSearch = () => {
      queryParams.value = {
        code: '',
        remark: '',
        is_active: ''
      }
      currentPage.value = 1
      fetchTags()
    }

    const openAddDialog = () => {
      addDialogVisible.value = true
      form.value = {
        code: '',
        is_active: true,
        sort: 0,
        remark: ''
      }
      if (formRef.value) {
        formRef.value.clearValidate()
      }
    }

    const onCodeInput = (value) => {
      form.value.code = (value || '').toUpperCase().replace(/[^A-X]/g, '')
    }

    const submitAdd = async () => {
      if (!formRef.value) return
      try {
        await formRef.value.validate()
      } catch (error) {
        return
      }
      try {
        await createProductTag(form.value)
        ElMessage.success('标签创建成功')
        addDialogVisible.value = false
        fetchTags()
      } catch (error) {
        console.error('创建标签失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const openEditDialog = (row) => {
      editDialogVisible.value = true
      currentEditId.value = row.id
      editForm.value = {
        code: row.code || '',
        is_active: !!row.is_active,
        sort: row.sort || 0,
        remark: row.remark || ''
      }
      if (editFormRef.value) {
        editFormRef.value.clearValidate()
      }
    }

    const submitEdit = async () => {
      if (!editFormRef.value) return
      try {
        await editFormRef.value.validate()
      } catch (error) {
        return
      }
      try {
        await updateProductTag(currentEditId.value, {
          is_active: editForm.value.is_active,
          sort: editForm.value.sort,
          remark: editForm.value.remark
        })
        ElMessage.success('标签更新成功')
        editDialogVisible.value = false
        fetchTags()
      } catch (error) {
        console.error('更新标签失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    onMounted(() => {
      fetchTags()
    })

    return {
      loading,
      tags,
      total,
      currentPage,
      pageSize,
      queryParams,
      addDialogVisible,
      formRef,
      form,
      rules,
      editDialogVisible,
      editFormRef,
      editForm,
      editRules,
      handleSizeChange,
      handleCurrentChange,
      handleSearch,
      resetSearch,
      openAddDialog,
      onCodeInput,
      submitAdd,
      openEditDialog,
      submitEdit
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 10px;
}
.filter-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filter-form-left {
  display: flex;
  align-items: center;
}
.table-card {
  margin-bottom: 10px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
